export var ModelBoundingType;
(function (ModelBoundingType) {
    ModelBoundingType[ModelBoundingType["box"] = 2] = "box";
    ModelBoundingType[ModelBoundingType["sphere"] = 3] = "sphere";
})(ModelBoundingType || (ModelBoundingType = {}));
